import { useState } from 'react'

import { useFetch } from '@reveni-io/reveni-ui'

import returnsServices from '@/returns/services/services'

const useEditCustomer = ({ fetchData, fetchTimeline, setToastInfo, returnId }) => {
  const [showEditCustomerModal, setShowEditCustomerModal] = useState(false)
  const { fetchData: editCustomer, loading: editingCustomer } = useFetch(returnsServices.editReturnCustomer, {
    doInitialRequest: false,
  })

  const onEditCustomer = async customer => {
    const customerPayload = { phone: customer.phone, email: customer.email, language: customer.language }

    try {
      await editCustomer({ returnId, customer: customerPayload })
      setShowEditCustomerModal(false)
      fetchData()
      fetchTimeline()
    } catch (err) {
      setToastInfo({ show: true, message: err.errorMessage, type: 'error' })
    }
  }

  const openEditCustomerModal = () => {
    setShowEditCustomerModal(true)
  }

  const closeEditCustomerModal = () => {
    setShowEditCustomerModal(false)
  }

  return {
    showEditCustomerModal,
    openEditCustomerModal,
    closeEditCustomerModal,
    editCustomer,
    editingCustomer,
    onEditCustomer,
  }
}

export default useEditCustomer
